<!--供应商统计模块-->
<template>
	<div class="info-item">
		<div id="main1" style="width: 600px;height:400px;"></div>
		<div id="main2" style="width: 600px;height:400px;"></div>
	</div>
</template>

<script>
	import {
		supplierInfoList,
		addSupplierInfo,
		editSupplierInfo,
		delSupplierInfo,
		batchDelSupplierInfo,
		exportSupplierInfo,
	} from '@/api/gys/supplierInfo.js'
	export default {
		name: "statistics",
		computed: {
		},
		data() {
			return {
				quertInfo:{
					page: 1, //当前页码
					limit: 100, //当前每页显示的数量
				},
				month1:0,
				month2:0,
				 month3:0,
				 month4:0,
				 month5:0,
				 month6:0,
				 month7:0,
				 month8:0,
				 month9:0,
				 month10:0,
				 month11:0,
				 month12:0,
				qylx1:{value:0,name:'外商投资企业'},
				qylx2:{value:0,name:'股份合作企业'},
				qylx3:{value:0,name:'港澳台企业'},
				qylx4:{value:0,name:'个人独资企业'},
				qylx5:{value:0,name:'国有企业'},
				qylx6:{value:0,name:'集体所有制企业'},
				qylx7:{value:0,name:'股份有限责任公司'},
				qylx8:{value:0,name:'私营企业'},
				qylx9:{value:0,name:'有限合伙企业'},
				qylx11:{value:0,name:'特殊普通合伙企业'},
				qylx12:{value:0,name:'外商企业'},
				qylx13:{value:0,name:'合作社'},
				qylx14:{value:0,name:'民办非企业单位'},
				qylx15:{value:0,name:'股份有限公司'},
				qylx16:{value:0,name:'有限责任公司'},
			};
		},
		mounted() {
			this.getList();

		},
		methods: {
            formatIsMainNum: function(row) {
				return row.isMainNum == 0 ? '是' : '否';
			},
			//获取所有供应商
			async getList() {
				this.quertInfo.page = 1;
				this.quertInfo.limit = 100;
				let _this = this;
				const { data: res } = await supplierInfoList(_this.quertInfo)
				let all = res.data;
				// 企业本年度准入数量
				if(all.length>0) {
					all.forEach(item =>{
						let time = item.createTime;
						let splitElement = time.split("-")[1];
						if (splitElement==3) {this.month3++;}
					})
				}
				this.drawChart();

				// 所有企业类型数量
				if(all.length>0) {
					all.forEach(item=>{
						let qyTyoe = item.qyTyoe;
						if(qyTyoe=="外商投资企业") {this.qylx1.value++;}
						if(qyTyoe=="股份合作企业") {this.qylx2.value++;}
						if(qyTyoe=="港澳台企业") {this.qylx3.value++;}
						if(qyTyoe=="个人独资企业") {this.qylx4.value++;}
						if(qyTyoe=="国有企业") {this.qylx5.value++;}
						if(qyTyoe=="集体所有制企业") {this.qylx6.value++;}
						if(qyTyoe=="股份有限责任公司") {this.qylx7.value++;}
						if(qyTyoe=="私营企业") {this.qylx8.value++;}
						if(qyTyoe=="有限合伙企业") {this.qylx9.value++;}
						if(qyTyoe=="特殊普通合伙企业") {this.qylx11.value++;}
						if(qyTyoe=="外商企业") {this.qylx12.value++;}
						if(qyTyoe=="合作社") {this.qylx13.value++;}
						if(qyTyoe=="民办非企业单位") {this.qylx14.value++;}
						if(qyTyoe=="股份有限公司") {this.qylx15.value++;}
						if(qyTyoe=="有限责任公司") {this.qylx16.value++;}
					})
				}
				this.drawChart2();
			},

			drawChart() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("main1"));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: "供应商本年度准入情况"
					},
					tooltip: {},
					legend: {
						data: ["数量"]
					},
					xAxis: {
						data: ["一月份", "二月份", "三月份", "四月份", "五月份", "六月份","七月份","八月份","九月份","十月份","十一月份","十二月份"]
					},
					yAxis: {},
					series: [
						{
							name: "销量",
							type: "bar",
							data: [this.month1, this.month2, this.month3, this.month4, this.month5, this.month6, this.month7, this.month8, this.month9, this.month10, this.month11, this.month12]
						}
					]
				};
				myChart.setOption(option);
			},
			drawChart2() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("main2"));
				// 指定图表的配置项和数据
				let option = option = {
					title: {
						text: '供应商企业类型分布',
						subtext: '所有供应商',
						left: 'center'
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						left: 'left'
					},
					series: [
						{
							name: '数量',
							type: 'pie',
							radius: '50%',
							data: [
								this.qylx1,
								this.qylx3,
								this.qylx4,
								this.qylx5,
								this.qylx6,
								this.qylx7,
								this.qylx8,
								this.qylx9,
								this.qylx11,
								this.qylx12,
								this.qylx13,
								this.qylx14,
								this.qylx15,
								this.qylx16,
								this.qylx17,

							],
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						}
					]
				};
				myChart.setOption(option);
			}
		}
	};
</script>
<style scoped="scoped">
</style>
